import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {HubEbicsSettings} from '../../model/hub-session';
import {HubApiService} from '../../services/hub-api.service';
import '@web.awesome.me/webawesome-pro/dist/components/icon/icon.js';
@Component({
  selector: 'hub-ebics',
  imports: [FormsModule],
  templateUrl: './ebics.component.html',
  styleUrl: './ebics.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EbicsComponent implements OnInit {
  ebics: HubEbicsSettings | null = null;
  loading = true;
  error = '';
  success = '';

  constructor(private hubApi: HubApiService) {
  }

  ngOnInit(): void {
    this.hubApi.loadEbics().subscribe({
      next: (response) => {
        this.ebics = response.ebics;
        this.loading = false;
      },
      error: (error) => {
        this.error = error.error?.message || this.t('HubEbicsLoadFailedMessage');
        this.loading = false;
      }
    });
  }

  save(): void {
    if (!this.ebics) return;
    this.error = '';
    this.success = '';
    this.hubApi.saveEbics(this.ebics).subscribe({
      next: (response) => {
        this.ebics = response.ebics;
        this.success = this.t('HubEbicsSavedMessage');
      },
      error: (error) => this.error = error.error?.message || this.t('HubEbicsSaveFailedMessage')
    });
  }

  t(key: string): string {
    return this.hubApi.translate(key) || key;
  }
}
